<div class="conn-card import-products" style="width: 100%">
  <app-report-top-filter-bar [paraReportName]="'importinventory'"></app-report-top-filter-bar>

  <div class="status-panel" *ngIf="importStatus==='started'">
    <i class="pi pi-spin pi-spinner status-icon info"></i>
    <h5>{{job ? 'Import is running in the background' : 'Uploading your file...'}}</h5>
    <ng-container *ngIf="job">
      <div class="progress"><div class="progress-bar" [style.width.%]="job.percentComplete || 0"></div></div>
      <p>{{job.status}} &bull; {{job.processedRows || 0}} of {{job.totalRows}} rows ({{job.percentComplete || 0}}%)</p>
      <p>You can keep working on other pages or close this tab. The import continues on the server, check Products later.</p>
    </ng-container>
    <p class="tip" *ngIf="!job"><i class="pi pi-exclamation-triangle"></i> Do not close or reload this browser tab until this step finishes.</p>
  </div>

  <div class="status-panel" *ngIf="importStatus==='completed'">
    <i class="pi pi-check-circle status-icon success"></i>
    <h5>Inventory import completed</h5>
    <p>{{importMessage}}</p>
    <div class="result-counts" *ngIf="job">
      <span class="count ok"><b>{{job.createdCount || 0}}</b> created</span>
      <span class="count ok" *ngIf="job.updatedCount"><b>{{job.updatedCount}}</b> updated</span>
      <span class="count warn"><b>{{job.skippedCount || 0}}</b> skipped</span>
      <span class="count bad"><b>{{job.failedCount || 0}}</b> failed</span>
    </div>
    <div class="job-issues" *ngIf="jobIssues.length">
      <div class="issue-item" *ngFor="let i of jobIssues | slice:0:maxShown">
        <div class="issue-meta">
          <span class="tag line" *ngIf="i.row">Line {{i.row}}</span>
          <span class="tag">{{i.outcome}}</span>
          <span class="tag" *ngIf="i.productName">{{i.productName}}</span>
        </div>
        <div class="issue-problem">{{i.reason}}</div>
      </div>
    </div>
    <div class="action-row">
      <p-button icon="pi pi-refresh" label="Import another file" (click)="reset()"></p-button>
      <p-button icon="pi pi-times" label="Close" styleClass="p-button-secondary" (click)="goBack()"></p-button>
    </div>
  </div>

  <div class="status-panel error-panel" *ngIf="importStatus==='error'">
    <i class="pi pi-times-circle status-icon danger"></i>
    <h5>Inventory import failed</h5>
    <p-messages severity="error"><ng-template pTemplate><span>{{importMessage}}</span></ng-template></p-messages>
    <ul class="issue-list" *ngIf="apiIssues.length">
      <li *ngFor="let i of apiIssues | slice:0:maxShown">{{apiIssueText(i)}}</li>
    </ul>
    <p *ngIf="apiIssues.length > maxShown">...and {{apiIssues.length - maxShown}} more.</p>
    <p-button icon="pi pi-arrow-left" label="Back" (click)="reset(true)"></p-button>
  </div>

  <div class="back-row" *ngIf="importStatus===''">
    <p-button icon="pi pi-arrow-left" label="Back" styleClass="p-button-secondary p-button-text" (click)="goBack()"></p-button>
  </div>

  <div class="grid import-grid import-content" *ngIf="importStatus===''">
    <div class="col-12 lg:col-8">
      <div class="nodata" *ngIf="activeLocations.length===0 && importType==='detailed'">
        <i class="pi pi-map-marker"></i>
        <p>No location exists to manage Stock, please add location first!</p>
        <p-button icon="pi pi-plus" label="Add Location" (click)="gotoaddlocation()"></p-button>
      </div>

      <div class="card import-card" *ngIf="activeLocations.length>0 || importType==='quick'">
        <!-- Step 1: import type -->
        <div class="step">
          <div class="step-head"><span class="step-no">1</span><h6>Choose import type</h6></div>
          <div class="option-grid two">
            <label class="option" [class.active]="importType==='quick'">
              <p-radioButton name="importtype" value="quick" [ngModel]="importType" (onClick)="setType('quick')"></p-radioButton>
              <span><b>Quick import</b><small>Name, category, prices and one picture.</small></span>
            </label>
            <label class="option" [class.active]="importType==='detailed'">
              <p-radioButton name="importtype" value="detailed" [ngModel]="importType" (onClick)="setType('detailed')"></p-radioButton>
              <span><b>Detailed import</b><small>All fields: variants, stock, shipping, tags and more.</small></span>
            </label>
          </div>
        </div>

        <!-- Step 2 (both import types) -->
        <div class="step">
          <div class="step-head"><span class="step-no">2</span><h6>Choose what to do with existing products</h6></div>
          <div class="p-float-label locationDropDown" *ngIf="activeLocations.length>1">
            <p-dropdown [style]="{ width: '100%', 'min-width': '120px' }" [options]="activeLocations"
              [(ngModel)]="selectedLocation" optionLabel="locationName"></p-dropdown>
            <label>Selection Location</label>
          </div>
          <div class="option-grid">
            <label class="option" [class.active]="importOption==='skip'">
              <p-radioButton name="importoption" value="skip" [(ngModel)]="importOption"></p-radioButton>
              <span><b>Skip existing products</b><small>Only new products are added.</small></span>
            </label>
            <label class="option" [class.active]="importOption==='updateProducts'">
              <p-radioButton name="importoption" value="updateProducts" [(ngModel)]="importOption"></p-radioButton>
              <span><b>Overwrite matching products</b><small>Existing products are replaced with file data.</small></span>
            </label>
            <label class="option" *ngIf="importType!=='quick'" [class.active]="importOption==='updateOnlyStocks'">
              <p-radioButton name="importoption" value="updateOnlyStocks" [(ngModel)]="importOption"></p-radioButton>
              <span><b>Only update stock</b><small>Only stock quantity of matching products changes.</small></span>
            </label>
          </div>
        </div>

        <!-- Select file -->
        <div class="step">
          <div class="step-head"><span class="step-no">3</span><h6>Select your CSV file</h6></div>
          <p class="quick-note" *ngIf="importType==='quick'">Existing products are handled as chosen in step 2. Only ProductName is required.</p>
          <input #fi type="file" accept=".csv" hidden (change)="onFileSelect($event)">
          <div class="drop-zone" [class.has-file]="file" [class.has-error]="issues.length" [class.is-dragover]="isDragOver"
            (click)="!file && fi.click()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
            <ng-container *ngIf="!file">
              <i class="pi pi-cloud-upload"></i>
              <b>Click to choose a CSV file</b>
              <small>.csv only &bull; Max file size : 5MB &bull; Up to {{cfg.maxRows}} rows</small>
            </ng-container>
            <ng-container *ngIf="file">
              <i class="pi" [ngClass]="validating ? 'pi-spin pi-spinner' : (issues.length ? 'pi-exclamation-triangle' : 'pi-file')"></i>
              <b class="file-name">{{file.name}}</b>
              <small>{{file.size | number}} bytes<span *ngIf="rowCount"> &bull; {{rowCount}} rows</span></small>
            </ng-container>
          </div>
          <div class="file-row">
            <p-button icon="pi pi-plus" [label]="file ? 'Change file' : 'Choose import file'" (click)="fi.click()"></p-button>
            <p-button icon="pi pi-upload" label="Upload" styleClass="p-button-success" [disabled]="!canUpload" (click)="upload()"></p-button>
            <p-button icon="pi pi-times" label="Cancel" styleClass="p-button-secondary" [disabled]="!file" (click)="clear()"></p-button>
          </div>

          <!-- Result of checking the file -->
          <div class="check-ok" *ngIf="file && !validating && issues.length===0">
            <i class="pi pi-check-circle"></i>
            <span>File looks good. {{rowCount}} rows ready to upload.</span>
          </div>

          <div *ngIf="issues.length" class="validation-errors">
            <div class="check-fail">
              <i class="pi pi-exclamation-circle"></i>
              <div>
                <b>{{issues.length}} issue(s) found in {{groups.length}} item(s). Nothing was sent.</b>
                <small>Fix the file, then choose it again.</small>
              </div>
            </div>
            <div class="product-issues" *ngFor="let g of groups | slice:0:maxShown">
              <div class="issue-title"><strong>{{g.product}}</strong> <span class="badge">{{g.issues.length}}</span></div>
              <div class="issue-item" *ngFor="let i of g.issues">
                <div class="issue-meta">
                  <span class="tag line" *ngIf="i.row">Line {{i.row}}</span>
                  <span class="tag col" *ngIf="i.column">Column: {{i.column}}</span>
                </div>
                <div class="issue-problem"><i class="pi pi-times-circle"></i> {{i.message}}</div>
                <div class="issue-value" *ngIf="i.value" [title]="i.value">Your value: <code>{{i.value}}</code></div>
                <div class="issue-fix"><i class="pi pi-check-circle"></i> {{i.fix}}</div>
              </div>
            </div>
            <small *ngIf="groups.length > maxShown">Showing first {{maxShown}} of {{groups.length}} items.</small>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-4 import-sidebar">
      <div class="guide-card">
        <h6><i class="pi pi-download"></i> Get a template</h6>
        <ng-container *ngIf="cfg.templateUrlQuick && cfg.templateUrlDetail; else singleTemplate">
          <a class="tpl-link" *ngIf="importType!=='detailed'" [href]="cfg.templateUrlQuick" target="_blank">
            <i class="pi pi-file-excel"></i>
            <span><b>Quick Template</b><small>Basic product details, fastest way to add products.</small></span>
          </a>
          <a class="tpl-link" [href]="cfg.templateUrlDetail" target="_blank">
            <i class="pi pi-file-excel"></i>
            <span><b>Detail Template</b><small>All fields: variants, shipping, stock levels and more.</small></span>
          </a>
        </ng-container>
        <ng-template #singleTemplate>
          <a class="tpl-link" [href]="cfg.templateUrl" target="_blank">
            <i class="pi pi-file"></i>
            <span><b>Download {{cfg.label}} Template File.</b></span>
          </a>
        </ng-template>
      </div>

      <div class="guide-card">
        <h6><i class="pi pi-info-circle"></i> How it works</h6>
        <p class="tip">Save your file as <b>CSV UTF-8 (Comma delimited)</b> before uploading.
          <a href="https://cloudstoragels.blob.core.windows.net/commonfiles/Production/Guide.txt" target="_blank" rel="noopener">How to save</a></p>
        <p class="tip">Keep the header row as in the template. Required: {{importType==='quick' ? 'ProductName' : 'ProductName, CostPrice, SalePriceA'}}. Max 5MB.</p>
      </div>
    </div>
  </div>
</div>
